import PreviewSection from './PreviewSection';

export { PreviewSection };
export default PreviewSection;
